import React, { Component, Fragment } from "react";
import { Card, CardBody, Row, Col, Form, Table, CardTitle } from "reactstrap";
import { Form as FinalForm } from "react-final-form";
import { withTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import {
  dataURItoBlob,
  i18nizeDate,
  mapTicketDepartment,
  selectStyles,
} from "../../../helpers/Utils";
import TextField from "../../../components/TextField";
import { Colxx } from "../../../components/common/CustomBootstrap";
import ModalManager from "../../../components/modal/ModalManager";
import { NotificationManager } from "../../../components/common/react-notifications";
import LoaderButton from "../../../components/LoaderButton";
import FileField from "../../../components/FileField";
import { capitalize, reduce } from "lodash";
import Rbac from "../../../components/Rbac";
import Api from "../../../services/Api";
import { Link } from "react-router-dom";
import Select from "react-select";
import Zoom from "react-medium-image-zoom";

class Ticket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tickets: [],
      loading: true,
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    const { threadId } = this.props.match.params;
    try {
      const { data } = await Api.invoke("GET", "/admin-ui/tickets", null, {
        params: {
          threadId,
        },
      });
      this.setState({
        tickets: data.tickets[0].reverse(),
      });
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  sendReply = async (values) => {
    const { t } = this.props;
    const formData = new FormData();
    const { attachment, reply, id } = values;
    formData.append("id", id);
    formData.append("reply", reply);
    formData.append("status", "REPLIED");
    if (attachment) {
      formData.append("attachment", dataURItoBlob(attachment));
    }
    try {
      await Api.invoke("PUT", "/admin-ui/tickets", formData);
      NotificationManager.success(t("Reply sent successfully"), t("Message"));
      await this.fetchData();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  getStatusOptions = (status) => {
    const { t } = this.props;
    const options = [
      { label: t("Waiting"), value: "PENDING" },
      { label: t("Replied"), value: "REPLIED" },
      { label: t("Closed"), value: "CLOSED" },
    ];
    return reduce(
      options,
      (result, element) => {
        if (element.value !== status) {
          return [...result, element];
        }
        return result;
      },
      []
    );
  };

  onChangeStatus = async (id, status) => {
    const { t } = this.props;
    const formData = new FormData();
    formData.append("id", id);
    formData.append("status", status.value);
    try {
      await Api.invoke("PUT", "/admin-ui/tickets", formData);
      NotificationManager.success(
        t("Ticket status updated successfully"),
        t("Message")
      );
      await this.fetchData();
    } catch (e) {
      console.log("error: ", e);
    }
  };

  render() {
    const { t } = this.props;
    const { tickets, loading } = this.state;
    return (
      <Fragment>
        {!loading ? (
          <Row>
            {tickets.map((ticket, index) => {
              const {
                id,
                userId,
                email,
                responderFirstName,
                responderLastName,
                responderUsername,
                firstName,
                lastName,
                title,
                section,
                description,
                createdAt,
                repliedAt,
                updatedAt,
                status,
                reply,
                attachment,
                replyAttachment,
              } = ticket;
              return (
                <Colxx xxs="12" className="mb-4" key={ticket.id}>
                  <Card className="h-100">
                    <CardBody>
                      <CardTitle className="text-large text-primary">
                        {index === 0 ? t("User Ticket") : t("User Reply")}
                      </CardTitle>
                      <Table bordered responsive className="mb-3 text-medium">
                        <tbody>
                          {index === 0 && (
                            <tr>
                              <td
                                className="text-info text-center"
                                style={{ width: "110px" }}
                              >
                                {t("User")}
                              </td>
                              <td className="d-flex flex-row align-items-center border-bottom-0 border-right-0">
                                <div>{`${firstName} ${lastName} [${email}]`}</div>
                                <Link
                                  to={{
                                    pathname: "/dashboard/users/" + userId,
                                  }}
                                >
                                  <div className="text-success mx-3">
                                    <i className="simple-icon-user" />
                                    <span className="mx-1">
                                      {t("User Account")}
                                    </span>
                                  </div>
                                </Link>
                              </td>
                            </tr>
                          )}
                          {index === 0 && (
                            <tr>
                              <td
                                className="text-info text-center"
                                style={{ width: "110px" }}
                              >
                                {t("Department")}
                              </td>
                              <td>{mapTicketDepartment(section)}</td>
                            </tr>
                          )}
                          {index === 0 && (
                            <tr>
                              <td
                                className="text-info text-center"
                                style={{ width: "110px" }}
                              >
                                {t("Title")}
                              </td>
                              <td>{title}</td>
                            </tr>
                          )}
                          <tr>
                            <td
                              className="text-info text-center"
                              style={{ width: "110px" }}
                            >
                              {t("Description")}
                            </td>
                            <td>{description}</td>
                          </tr>
                          <tr>
                            <td
                              className="text-info text-center"
                              style={{ width: "110px" }}
                            >
                              {t("Register Date")}
                            </td>
                            <td>{i18nizeDate(createdAt)}</td>
                          </tr>
                          {!!attachment && (
                            <tr>
                              <td
                                className="text-info text-center"
                                style={{ width: "110px" }}
                              >
                                {t("Attached Image")}
                              </td>
                              <td>
                                <img
                                  onClick={() => {
                                    ModalManager.open({
                                      size: "lg",
                                      isOpen: true,
                                      title: t("Attached Image"),
                                      body: (
                                        <Zoom>
                                          <img
                                            src={attachment}
                                            width="100%"
                                            height="100%"
                                          />
                                        </Zoom>
                                      ),
                                    });
                                  }}
                                  src={attachment}
                                  height="250px"
                                  width="250px"
                                />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      {!!reply && (
                        <Table
                          bordered
                          responsive
                          className="mb-3 text-medium ticket-reply-table"
                        >
                          <tbody>
                            {!!responderUsername && (
                              <tr>
                                <td
                                  className="text-white text-center ticket-reply-td"
                                  style={{ width: "110px" }}
                                >
                                  {t("Admin")}
                                </td>
                                <td>{`${
                                  responderFirstName
                                    ? `${responderFirstName} ${responderLastName} `
                                    : ""
                                }[${responderUsername}]`}</td>
                              </tr>
                            )}
                            <tr>
                              <td
                                className="text-white text-center ticket-reply-td"
                                style={{ width: "110px" }}
                              >
                                {t("Admin Reply")}
                              </td>
                              <td>
                                {reply
                                  ?.split(/\r\n|\r|\n/)
                                  ?.map((line, idx) => (
                                    <React.Fragment key={idx}>
                                      {line}
                                      <br />
                                    </React.Fragment>
                                  ))}
                              </td>
                            </tr>
                            {!!replyAttachment && (
                              <tr>
                                <td
                                  className="text-white text-center ticket-reply-td"
                                  style={{ width: "110px" }}
                                >
                                  {t("Attached Image")}
                                </td>
                                <td>
                                  <img
                                    onClick={() => {
                                      ModalManager.open({
                                        size: "lg",
                                        isOpen: true,
                                        title: t("Attached Image"),
                                        body: (
                                          <Zoom>
                                            <img
                                              src={attachment}
                                              width="100%"
                                              height="100%"
                                            />
                                          </Zoom>
                                        ),
                                      });
                                    }}
                                    src={replyAttachment}
                                    height="250px"
                                    width="250px"
                                  />
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td
                                className="text-white text-center ticket-reply-td"
                                style={{ width: "110px" }}
                              >
                                {t("Register Date")}
                              </td>
                              <td>{i18nizeDate(repliedAt || updatedAt)}</td>
                            </tr>
                          </tbody>
                        </Table>
                      )}
                      {index === tickets.length - 1 && (
                        <div className="mb-3">
                          <div>{t("Status")}</div>
                          <div
                            className="font-weight-semibold"
                            style={{ width: 250 }}
                          >
                            <Select
                              styles={selectStyles}
                              value={{
                                label:
                                  status === "PENDING"
                                    ? t("Waiting")
                                    : t(capitalize(status)),
                                value: status,
                              }}
                              options={this.getStatusOptions(status)}
                              onChange={(status) =>
                                this.onChangeStatus(id, status)
                              }
                            />
                          </div>
                        </div>
                      )}
                      {status === "PENDING" && (
                        <Rbac permission="update_tickets">
                          <FinalForm
                            onSubmit={this.sendReply}
                            initialValues={{ id }}
                            render={({
                              handleSubmit,
                              submitting,
                              pristine,
                              hasValidationErrors,
                            }) => {
                              return (
                                <Form onSubmit={handleSubmit}>
                                  <Row>
                                    <Col>
                                      <TextField
                                        item={{
                                          name: "reply",
                                          i18n: t("Reply"),
                                          type: "textarea",
                                          rows: 4,
                                          required: true,
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col className="col-lg-6 col-md-12">
                                      <FileField
                                        item={{
                                          name: "attachment",
                                          i18n: t("Attached Image"),
                                          accept: "image/png,image/jpeg",
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                  <LoaderButton
                                    loading={submitting}
                                    onClick={handleSubmit}
                                    disabled={
                                      pristine ||
                                      hasValidationErrors ||
                                      submitting
                                    }
                                    className="mt-3 text-center"
                                    style={{ minWidth: "100px" }}
                                  >
                                    {t("Send")}
                                  </LoaderButton>
                                </Form>
                              );
                            }}
                          />
                        </Rbac>
                      )}
                    </CardBody>
                  </Card>
                </Colxx>
              );
            })}
          </Row>
        ) : (
          <Row>
            <Colxx xxs="12" className="mb-4">
              <Card className="h-100 p-5">
                <Skeleton count={8} height={50} />
              </Card>
            </Colxx>
          </Row>
        )}
      </Fragment>
    );
  }
}

export default withTranslation()(Ticket);
